
import { Component, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import { PageMode } from "@/utils/type";
import {
    apiAppUpdateLists,
    apiAppUpdateDel,
    apiAppUpdateChangeStatus,
} from "@/api/setting";

@Component({
    components: {
        LsPagination,
        LsDialog,
    },
})
export default class AppUpdateLists extends Vue {
    /** S Data **/
    pager: RequestPaging = new RequestPaging();

    form: any = {
        platform: "",
        client_type: "",
        status: "",
        is_force: "",
        sid: "",
        version_name: "",
    };

    $refs!: { formRef: any };

    /** E Data **/

    /** S Methods **/
    getList() {
        this.pager.request({
            callback: apiAppUpdateLists,
            params: {
                ...this.form,
                // sid 是字符串时按 0 处理（全平台）
                sid: this.form.sid === "" ? "" : Number(this.form.sid),
            },
        });
    }

    onReset() {
        Object.keys(this.form).forEach((key) => {
            this.$set(this.form, key, "");
        });
        this.getList();
    }

    goAdd() {
        this.$router.push({
            path: "/setting/app_update/edit",
            query: { mode: PageMode["ADD"] },
        });
    }

    goEdit(id: number) {
        this.$router.push({
            path: "/setting/app_update/edit",
            query: { id: id as any, mode: PageMode["EDIT"] },
        });
    }

    async onDel(id: number) {
        await apiAppUpdateDel({ id });
        this.getList();
    }

    async onChangeStatus(row: any) {
        try {
            await apiAppUpdateChangeStatus({ id: row.id, status: row.status });
        } catch (e) {
            // 失败时还原开关
            row.status = row.status == 1 ? 0 : 1;
        }
    }

    platformLabel(p: string) {
        const map: Record<string, string> = {
            android: "Android",
            ios: "iOS",
            h5: "H5",
            "mp-weixin": "微信小程序",
        };
        return map[p] || p;
    }

    clientTypeLabel(t: string) {
        const map: Record<string, string> = {
            app: "原生 App",
            mp: "小程序",
        };
        return map[t] || t;
    }

    formatSize(bytes: number): string {
        if (!bytes || bytes <= 0) return "-";
        const units = ["B", "KB", "MB", "GB"];
        let i = 0;
        let v = bytes;
        while (v >= 1024 && i < units.length - 1) {
            v = v / 1024;
            i++;
        }
        return `${v.toFixed(v < 10 && i > 0 ? 2 : 1)} ${units[i]}`;
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getList();
    }
    /** E Life Cycle **/
}
